import { applyManualSubsidy } from './applyManualSubsidy';
import { assignPartnerToRide } from './assignPartnerToRide';
import { chargeForUnpaidRideImmediately } from './chargeForUnpaidRideImmediately';
import { copyRideToAnotherUserAndClearCharges } from './copyRideToAnotherUserAndClearCharges';
import { downloadNumberOfRidesTakenPerUser } from './downloadNumberOfRidesTakenPerUser';
import { fetchPrefilledRideAddresses } from './fetchPrefilledRideAddresses';
import { fetchRideCustomChargeRecords } from './fetchRideCustomChargeRecords';
import { getActiveRide } from './getActiveRide';
import { getActiveRideWithIsVendorRide } from './getActiveRideWithIsVendorRide';
import { getNumberOfRidesPerUser } from './getNumberOfRidesPerUser';
import { getPartnerActiveRides } from './getPartnerActiveRides';
import { markLocalTaxiRequestConfirmed } from './markLocalTaxiRequestConfirmed';
import { markRide } from './markRide';
import { markRideAsDoNotCharge } from './markRideAsDoNotCharge';
import { repollAndMarkRide } from './repollAndMarkRide';
import { sendPharmacyDriverArrivedCall } from './sendPharmacyDriverArrivedCall';
import { tipDriver } from './tipDriver';
import { unmarkAutoRetryGettingEstimate } from './unmarkAutoRetryGettingEstimate';
import { unmarkRide } from './unmarkRide';
import { unmarkRideFromDoNotCharge } from './unmarkRideFromDoNotCharge';
import { updateLocalTaxiPartnerRide } from './updateLocalTaxiPartnerRide';

export const rideService = {
  applyManualSubsidy,
  assignPartnerToRide,
  chargeForUnpaidRideImmediately,
  copyRideToAnotherUserAndClearCharges,
  downloadNumberOfRidesTakenPerUser,
  fetchPrefilledRideAddresses,
  fetchRideCustomChargeRecords,
  getActiveRide,
  getActiveRideWithIsVendorRide,
  getNumberOfRidesPerUser,
  getPartnerActiveRides,
  markLocalTaxiRequestConfirmed,
  markRide,
  markRideAsDoNotCharge,
  repollAndMarkRide,
  sendPharmacyDriverArrivedCall,
  tipDriver,
  unmarkAutoRetryGettingEstimate,
  unmarkRide,
  unmarkRideFromDoNotCharge,
  updateLocalTaxiPartnerRide,
};
